import React from "react";
import { Button, Link, parseReplace } from "components";
import { CmsContentElement } from "../../cmscontent.types";
import { DomElement, attributesToProps, domToReact } from "html-react-parser";

export const CmsContent_Class_Secondary_Button_Dark: CmsContentElement = [
  "button--secondary-dark",
  (domNode: DomElement) =>
    domNode?.children && domNode.attribs ? (
      <Link {...attributesToProps(domNode.attribs)} to={domNode.attribs.href}>
        <Button rightIcon="ArrowLink" variant="outline" colorScheme="secondaryalt">
          {domToReact(domNode.children, { replace: parseReplace })}
        </Button>
      </Link>
    ) : null,
];
